export default "__VITE_ASSET__DqHGFTlj__"